export default __webpack_public_path__ + "static/media/Note_6_img.313493af.jpg";